import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { JhiLanguageService, DataUtils } from 'ng-jhipster';
import { Seller } from './seller.model';
import { SellerService } from './seller.service';

@Component( {
    selector: 'dcs-seller-detail',
    templateUrl: './seller-detail.component.html'
} )
export class SellerDetailComponent implements OnInit, OnDestroy {

    seller: Seller;
    private subscription: any;

    constructor(private jhiLanguageService: JhiLanguageService,
                private dataUtils: DataUtils,
                private sellerService: SellerService,
                private route: ActivatedRoute) {
        this.jhiLanguageService.setLocations( [ 'seller' ] );
    }

    ngOnInit() {
        this.subscription = this.route.params.subscribe( params => {
            this.load( params[ 'id' ] );
        } );
    }

    load(id) {
        this.sellerService.find( id ).subscribe( seller => {
            this.seller = seller;
        } );
    }

    touch() {
        this.sellerService.touch( this.seller.id ).subscribe( seller => {
            this.load( this.seller.id );
        } );
    }

    byteSize(field) {
        return this.dataUtils.byteSize( field );
    }

    openFile(contentType, field) {
        return this.dataUtils.openFile( contentType, field );
    }

    previousState() {
        window.history.back();
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/seller/seller-detail.component.ts